// MWC Watch Detail - Render module
// Builds gallery HTML, display/master helper values and the final watch detail template HTML.
// Keep customer-facing rendering logic here.

(function () {
  window.MWCWatchDetailRender = {
    renderPhotoHtml: renderPhotoHtml,
    createDisplayHelpers: createDisplayHelpers,
    renderTemplateHtml: renderTemplateHtml
  };

  function renderPhotoHtml(watch) {
    const photos = window.MWCWatchDetailUtils.parsePhotos(watch.photos);

    if (!Array.isArray(photos) || !photos.length) {
      return "";
    }

    const mainPhoto = photos[0];
    const thumbnails = photos.slice(0, 5);

    return `
      <div class="mwc-watch-detail-gallery" style="display:grid;gap:8px;">
        <div style="aspect-ratio:1/1;overflow:hidden;border:1px solid #ddd;">
          <img
            src="${mainPhoto}"
            alt=""
            data-mwc-main-photo
            style="width:100%;height:100%;object-fit:cover;display:block;"
          >
        </div>

        ${thumbnails.length ? `
          <div style="display:flex;gap:8px;flex-wrap:wrap;">
            ${thumbnails.map(function (url, index) {
              return `
                <div
                  style="width:84px;display:grid;gap:6px;"
                  data-mwc-thumb-wrapper="${index}"
                >
                  <button
                    type="button"
                    data-mwc-thumb="${url}"
                    data-mwc-thumb-index="${index}"
                    aria-pressed="${index === 0 ? "true" : "false"}"
                    style="display:block;width:84px;aspect-ratio:1/1;overflow:hidden;border:${index === 0 ? "2px solid #111" : "1px solid #ddd"};padding:0;background:none;"
                  >
                    <img
                      src="${url}"
                      alt=""
                      style="width:100%;height:100%;object-fit:cover;display:block;"
                    >
                  </button>

                  ${index !== 0 ? `
                    <button
                      type="button"
                      class="mwc-set-main-photo-button hidden"
                      data-mwc-set-main-photo-disabled="${url}"
                    >
                      Set main
                    </button>
                    <button
                      type="button"
                      class="mwc-delete-photo-button hidden"
                      data-mwc-delete-photo="${url}"
                    >
                      Delete
                    </button>
                  ` : ""}
                </div>
              `;
            }).join("")}
          </div>
        ` : ""}

        <div style="margin-top:8px;">
          <input
            type="file"
            accept="image/*"
            multiple
            data-mwc-upload-photos
            style="font-size:12px;"
          >
        </div>
      </div>
    `;
  }
 

  function createDisplayHelpers(watch, masterWatch) {
    const status = String((watch && watch.status) || "").toLowerCase();

    const masterData =
        masterWatch && masterWatch.watch
        ? masterWatch.watch
        : (masterWatch || null);

    function getDisplayValue(field) {
        const userValue = watch && watch[field] != null ? watch[field] : "";

        const masterValue =
        masterData && masterData[field] != null
            ? masterData[field]
            : "";

        const masterFields = ["brand", "model", "reference"];

        if (status === "matched") {
        if (masterFields.includes(field)) {
            return masterValue || userValue || "";
        }

        return userValue || masterValue || "";
        }

        return userValue || "";
    }

    function getMasterValue(field) {
        return masterData && masterData[field] != null
        ? String(masterData[field])
        : "";
    }

    function getUserValue(field) {
        return watch && watch[field] != null ? String(watch[field]) : "";
    }

    function isCustomValue(field) {
        const userValue = getUserValue(field).trim();
        const masterValue = getMasterValue(field).trim();

        return userValue && userValue !== masterValue;
    }

    function getTitleBrand() {
        return status === "matched"
        ? (getDisplayValue("brand") || watch.brand || "")
        : (watch.brand || "");
    }

    function getTitleModel() {
        return status === "matched"
        ? (getDisplayValue("model") || watch.model || "")
        : (watch.model || "");
    }

    return {
        status: status,
        masterData: masterData,
        getDisplayValue: getDisplayValue,
        getMasterValue: getMasterValue,
        getUserValue: getUserValue,
        isCustomValue: isCustomValue,
        getTitleBrand: getTitleBrand,
        getTitleModel: getTitleModel
    };
    }

    function renderTemplateHtml(template, watch, photoHtml, displayHelpers) {
        const getDisplayValue = displayHelpers.getDisplayValue;
        const getMasterValue = displayHelpers.getMasterValue;

        const titleBrand = displayHelpers.getTitleBrand();
        const titleModel = displayHelpers.getTitleModel();

        return template
            .replace(/__WATCH_PHOTOS__/g, photoHtml)
            .replace(/__WATCH_TITLE__/g, (titleBrand + " " + titleModel).trim())
            .replace(/__WATCH_REFERENCE__/g, getDisplayValue("reference"))
            .replace(/__WATCH_ID__/g, watch.id || "")
            .replace(/__WATCH_YEAR__/g, watch.year || "")
            .replace(/__WATCH_MOVEMENT__/g, getDisplayValue("movement"))
            .replace(/__WATCH_CASE_DIAMETER__/g, getDisplayValue("case_diameter"))
            .replace(/__WATCH_DIAL_COLOR__/g, getDisplayValue("dial_color"))
            .replace(/__WATCH_BRACELET_TYPE__/g, getDisplayValue("bracelet_type"))
            .replace(/__WATCH_YEARS__/g, getDisplayValue("years"))
            .replace(/__WATCH_MOVEMENT_TYPE__/g, getDisplayValue("movement_type"))
            .replace(/__WATCH_MOVEMENT_JEWELS__/g, getDisplayValue("movement_jewels"))
            .replace(/__WATCH_CASE_MATERIAL__/g, getDisplayValue("case_material"))
            .replace(/__WATCH_CASE_THICKNESS__/g, getDisplayValue("case_thickness"))
            .replace(/__WATCH_CRYSTAL__/g, getDisplayValue("crystal"))
            .replace(/__WATCH_BEZEL_TYPE__/g, getDisplayValue("bezel_type"))
            .replace(/__WATCH_CASEBACK_TYPE__/g, getDisplayValue("caseback_type"))
            .replace(/__WATCH_LUG_WIDTH__/g, getDisplayValue("lug_width"))
            .replace(/__WATCH_DIAL_TYPE__/g, getDisplayValue("dial_type"))
            .replace(/__WATCH_LUME_MATERIAL__/g, getDisplayValue("lume_material"))
            .replace(/__WATCH_HANDS_STYLE__/g, getDisplayValue("hands_style"))
            .replace(/__WATCH_BRACELET_REFERENCE__/g, getDisplayValue("bracelet_reference"))
            .replace(/__WATCH_ENDLINKS__/g, getDisplayValue("endlinks"))
            .replace(/__WATCH_NOTABLE_VARIANTS__/g, getDisplayValue("notable_variants"))
            .replace(/__WATCH_SERIAL_NUMBER_RANGE__/g, getDisplayValue("serial_number_range"))
            .replace(/__WATCH_COLLECTIBILITY_NOTES__/g, getDisplayValue("collectibility_notes"))
            .replace(/__WATCH_PRODUCTION_PERIOD__/g, getDisplayValue("production_period"))

            .replace(/__MASTER_MOVEMENT__/g, getMasterValue("movement"))
            .replace(/__MASTER_MOVEMENT_TYPE__/g, getMasterValue("movement_type"))
            .replace(/__MASTER_MOVEMENT_JEWELS__/g, getMasterValue("movement_jewels"))

            .replace(/__MASTER_CASE_MATERIAL__/g, getMasterValue("case_material"))
            .replace(/__MASTER_CASE_DIAMETER__/g, getMasterValue("case_diameter"))
            .replace(/__MASTER_CASE_THICKNESS__/g, getMasterValue("case_thickness"))
            .replace(/__MASTER_CRYSTAL__/g, getMasterValue("crystal"))
            .replace(/__MASTER_BEZEL_TYPE__/g, getMasterValue("bezel_type"))
            .replace(/__MASTER_CASEBACK_TYPE__/g, getMasterValue("caseback_type"))
            .replace(/__MASTER_LUG_WIDTH__/g, getMasterValue("lug_width"))

            .replace(/__MASTER_DIAL_COLOR__/g, getMasterValue("dial_color"))
            .replace(/__MASTER_DIAL_TYPE__/g, getMasterValue("dial_type"))
            .replace(/__MASTER_LUME_MATERIAL__/g, getMasterValue("lume_material"))
            .replace(/__MASTER_HANDS_STYLE__/g, getMasterValue("hands_style"))

            .replace(/__MASTER_BRACELET_TYPE__/g, getMasterValue("bracelet_type"))
            .replace(/__MASTER_BRACELET_REFERENCE__/g, getMasterValue("bracelet_reference"))
            .replace(/__MASTER_ENDLINKS__/g, getMasterValue("endlinks"))

            .replace(/__MASTER_COLLECTIBILITY_NOTES__/g, getMasterValue("collectibility_notes"))
            .replace(/__MASTER_PRODUCTION_PERIOD__/g, getMasterValue("production_period"));
        }


     

})();